/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Container, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useGradingGroupListingState, buildGradingListParams } from './GradingListionProvider';
import { checkArray, shortenandHoverString } from '../../../../Components/helper';
import { clearReducer, duplicateGradingGroup, fetchGradingGroupData, updateGradingGroupStatus } from '../Store/Pom.action';
import Loader from '../../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import '../Pom.css';

function ListingTable({ handleSingleDelete }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const listInnerRef = useRef();
  const { gradingListingState, setgradingListing, GradingAddEditAccess, GradingDeleteAccess, loggedInUserId, isallChecked, handleCheckAll } =
    useGradingGroupListingState();
  const { ListingData, duplicateData } = gradingListingState;
  const history = useHistory();
  const handlePageNextInScroll = async () => {
    let pageIndex = gradingListingState?.pageIndex;
    pageIndex += 1;
    setgradingListing((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      isPageLoader: true,
    }));
    const params = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex, isScrolled: true });

    const res = await dispatch(fetchGradingGroupData(params));
    if (res) {
      setgradingListing((prevState) => ({
        ...prevState,
        isPageLoader: false,
      }));
    }
  };

  const handleCheckTemplate = async (isTempChecked, tempId) => {
    const existingIds = gradingListingState?.selectedGrading;
    if (isTempChecked && !existingIds.includes(tempId)) {
      setgradingListing((prevState) => ({
        ...prevState,
        selectedGrading: [...existingIds, tempId],
      }));
    } else {
      const removedArray = existingIds?.filter((eleId) => eleId !== tempId);

      if (checkArray(removedArray)) {
        setgradingListing((prevState) => ({
          ...prevState,
          selectedGrading: removedArray,
        }));
      } else {
        setgradingListing((prevState) => ({
          ...prevState,
          selectedGrading: [],
        }));
      }
    }
  };

  const handleDuplicateById = async (libId) => {
    setgradingListing((prevState) => ({
      ...prevState,
      duplicateModal: true,
      duplicateData: { libId },
    }));
  };

  const confirmDuplicateLibrary = async () => {
    if (duplicateData?.moduleName !== undefined && duplicateData?.moduleName !== '') {
      const req = {
        id: duplicateData.libId,
        name: duplicateData.moduleName,
        loggedInUserId,
      };

      const res = await dispatch(duplicateGradingGroup(req, t));

      if (res?.code === 200) {
        dispatch(clearReducer());
        setgradingListing((prevState) => ({
          ...prevState,
          ListingData: [],
        }));

        const reqObj = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex: 1 });

        await dispatch(fetchGradingGroupData(reqObj));

        setgradingListing((prevState) => ({
          ...prevState,
          duplicateModal: false,
          duplicateData: null,
        }));
      } else {
        setgradingListing((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      }
    } else {
      toasterMsg(t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.GROUP_NAME_REQUIRED'), 'danger');
    }
  };

  const handleCloseDuplicateModal = () => {
    setgradingListing((prevState) => ({
      ...prevState,
      duplicateModal: false,
      duplicateData: null,
    }));
  };

  const handleDuplicateName = (e) => {
    setgradingListing((prevState) => ({
      ...prevState,
      duplicateData: { ...duplicateData, moduleName: e.target.value.trim() },
    }));
  };

  const showCreatedandModified = (item) => {
    return (
      <button type="button" className="btn p-0">
        <OverlayTrigger
          placement="bottom"
          trigger="hover"
          rootClose
          overlay={
            <Popover className="custom-popover modified-popover">
              <Popover.Content>
                <div>
                  <p className="text-left m-0">
                    <strong> {t('COLOR_WAY_CARD.CREATED_BY_DATE_TIME')} </strong> {item.createdBy}{' '}
                    {item.createdAt && moment(item.createdAt).format('DD-MMM-YYYY, HH:mm')}
                  </p>
                  {item?.modifiedBy && (
                    <p className="text-left m-0">
                      <strong> {t('COLOR_WAY_CARD.MODIFIED_BY_DATE_TIME')} </strong> {item.modifiedBy}{' '}
                      {item.lastModifiedAt && moment(item.lastModifiedAt).format('DD-MMM-YYYY, HH:mm')}
                    </p>
                  )}
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon icon-Information f-20" />
        </OverlayTrigger>
      </button>
    );
  };

  const activeInactiveClicked = async (ele) => {
    const req = {
      gradingLibraryId: ele?._id,
      isPublished: !ele?.isPublished,
      loggedInUserId,
    };

    const res = await dispatch(updateGradingGroupStatus(req, t));
    if (res) {
      dispatch(clearReducer());
      setgradingListing((prevState) => ({
        ...prevState,
        ListingData: [],
      }));

      const reqObj = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex: 1 });

      await dispatch(fetchGradingGroupData(reqObj));
    }
  };

  return (
    <Container fluid>
      <div id="scrollableDiv_PIM" ref={listInnerRef} className="grading-group-listing pom-sroll-container">
        <InfiniteScroll
          dataLength={ListingData?.length}
          loader={gradingListingState?.isPageLoader && <Loader />}
          hasMore={gradingListingState?.hasMore}
          next={handlePageNextInScroll}
          scrollableTarget="scrollableDiv_PIM"
          className="fixed-col-container"
        >
          <table className="table fixed-header common-custom-table m-0 grading-group-table">
            <thead>
              <th className="w-50px w-xs-40px ">
                <div className="common-checkbox margin-auto">
                  <input type="checkbox" name="check_all_symbol" id="check_all_symbol" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
                  <label htmlFor="check_all_symbol" className="chklabel" />
                </div>
              </th>
              <th className="w-224px  text-left first-fix-col ">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.GRADING_NAME')}</th>
              <th className="w-224px">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.BRAND')}</th>
              {gradingListingState?.isSubBrandAccess && <th className="w-224px">{t('POMS.GRADING_GROUP_LISTING.GRADING_FILTER.SUB_BRAND')}</th>}
              {gradingListingState?.catBasedOnPTData && <th className="w-224px">Product Type</th>}
              <th className="w-224px">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.CATEGORY_1')}</th>
              <th className="w-224px">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.CATEGORY_2')}</th>
              <th className="w-224px">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.CATEGORY_3')}</th>
              <th className="w-250px">{t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.SIZE_RANGE')}</th>
              <th aria-label="test" className="w-224px last-fix-col table-heading " />
            </thead>
            <tbody>
              {checkArray(ListingData) ? (
                ListingData.map((ele, i) => {
                  return (
                    <tr key={ele?._id}>
                      <td className="text-left">
                        <div className="common-checkbox margin-auto">
                          <input
                            type="checkbox"
                            name={`symbol_${i}`}
                            id={`symbol_${i}`}
                            checked={gradingListingState?.selectedGrading?.includes(ele._id)}
                            onChange={(e) => handleCheckTemplate(e.target.checked, ele._id)}
                          />
                          <label htmlFor={`symbol_${i}`} className="chklabel" />
                        </div>
                      </td>
                      <td className="text-left text-word-wrap first-fix-col">
                        <Link className="p-0 text-black text-bold f-16 text-decoration-underline" to={`/libraries/gradings/edit/${ele?._id}`}>
                          {ele?.name} - {shortenandHoverString(ele?.description, 30)}
                        </Link>
                      </td>
                      <td>{ele?.brand?.length ? shortenandHoverString(ele?.brand?.map((brandData) => brandData?.name).join(', '), 30) : '-'}</td>
                      {gradingListingState?.isSubBrandAccess && (
                        <td>
                          {shortenandHoverString(
                            ele.subBrandId
                              ?.filter((subBrandData) => subBrandData?.isActive)
                              ?.map((subBrandData) => subBrandData?.name)
                              ?.join(', '),
                            30,
                          )}
                        </td>
                      )}
                      {gradingListingState?.catBasedOnPTData && (
                        <td>{shortenandHoverString(ele?.productTypeId?.map((productTypeData) => productTypeData?.name).join(', '), 30)}</td>
                      )}
                      <td>{shortenandHoverString(ele?.catOnes?.map((catOneData) => catOneData).join(', '), 30)}</td>
                      <td>{shortenandHoverString(ele?.catTwos?.map((catTwoData) => catTwoData).join(', '), 30)}</td>
                      <td>{shortenandHoverString(ele?.catThrees?.map((catThreeData) => catThreeData).join(', '), 30)}</td>
                      <td>
                        {ele?.sizeRanges.map((sizeRange, index) => {
                          return (
                            <React.Fragment key={sizeRange.name}>
                              <span>{!sizeRange.isSampleSize ? <span>{sizeRange.name}</span> : <b>{sizeRange.name}</b>}</span>
                              {ele.sizeRanges.length > 1 && index < ele.sizeRanges.length - 1 && <span>, </span>}
                            </React.Fragment>
                          );
                        })}
                      </td>
                      <td className="last-fix-col grading-group-listing">
                        <div className="d-flex pom-action justify-content-end align-items-center">
                          {GradingAddEditAccess && (
                            <CustomTooltip tooltipText={t('COMMON_LABEL.EDIT')}>
                              <button
                                type="button"
                                aria-label="edit"
                                className="btn p-0 text-decoration-none"
                                onClick={() => history.push(`/libraries/gradings/edit/${ele?._id}`)}
                              >
                                <i className="icon-Edit-1 f-20" />
                              </button>
                            </CustomTooltip>
                          )}
                          {GradingDeleteAccess && !ele.development_orders.length && (
                            <CustomTooltip tooltipText={t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.DELETE')}>
                              <button className="btn p-0" type="button" onClick={() => handleSingleDelete(ele?._id)} aria-label="Delete">
                                <i className="icon-Delete f-20" />
                              </button>
                            </CustomTooltip>
                          )}
                          {GradingAddEditAccess && (
                            <CustomTooltip tooltipText={t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.DUPLICATE')}>
                              <button className="btn p-0" aria-label="copy" type="button" onClick={() => handleDuplicateById(ele._id)}>
                                <i className="icon-Duplicate-New f-20" />
                              </button>
                            </CustomTooltip>
                          )}
                          {GradingAddEditAccess && (
                            <CustomTooltip
                              tooltipText={
                                ele.isPublished
                                  ? t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.ACTIVE')
                                  : t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.INACTIVE')
                              }
                            >
                              <button className="btn p-0" aria-label="active" onClick={() => activeInactiveClicked(ele)} id={ele._id} type="button">
                                <i className={ele.isPublished ? 'icon-Eye-Open f-20' : 'icon-Eye-Closed f-20'} />
                              </button>
                            </CustomTooltip>
                          )}
                          {showCreatedandModified(ele)}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={8 + (gradingListingState?.isSubBrandAccess ? 1 : 0) + (gradingListingState?.catBasedOnPTData ? 1 : 0)}>
                    <span className="align-items-center justify-content-center d-flex">
                      {t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.NO_ENTRY_FOUND')}
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      {gradingListingState?.duplicateModal && (
        <ConfirmationPopup
          onOpen={gradingListingState?.duplicateModal}
          onConfirm={() => confirmDuplicateLibrary()}
          title={t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.GRADING_GROUP_NAME')}
          message=""
          toggle={() => handleCloseDuplicateModal()}
          isDuplicateLibrary
          isGrading
          moduleName={t('POMS.GRADING_GROUP_LISTING.GROUP_LISTING_TABLE.GRADING_GROUP_NAME')}
          handleDuplicateName={handleDuplicateName}
        />
      )}
    </Container>
  );
}

export default ListingTable;
